
import { computed, defineComponent, ref } from 'vue';
import Navbar from './components/Navbar.vue';
import { useModal } from './useModal';

export default defineComponent({
  name: 'App',
  components: { Navbar },
  setup() {
    const modal = useModal();

    const style = computed(() => {
      return {
        display: modal.show.value ? 'block' : 'none',
      };
    });
    return {
      style,
      hide: () => {
        modal.hideModal();
      },
    };
  },
});
